import { FileData } from './types';

export const MAX_UPLOAD_SIZE_IN_BYTES = 10 * 1024 * 1024; // 10 MB

export const SupportedFileTypes = {
  'application/pdf': 'pdf',
};

export const SupportedTemplateFileTypes = {
  'application/pdf': 'pdf',
};

export const SupportedDocFileTypes = {
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
};

export const getSupportedExtensionsString = (isTemplate?: boolean, isDocx?: boolean): string => {
  if (isDocx) {
    return Object.values(SupportedDocFileTypes).join(', ');
  }
  const types = isTemplate ? SupportedTemplateFileTypes : SupportedFileTypes;
  return Object.values(types).join(', ');
};

export const readFileAsBase64 = (file: File): Promise<FileData> => {
  return new Promise((resolve, reject) => {
    if (file.size > MAX_UPLOAD_SIZE_IN_BYTES) {
      reject(new Error(`File size should not exceed ${MAX_UPLOAD_SIZE_IN_BYTES / (1024 * 1024)} MB`));
      return;
    }

    const fileNameParts = file.name.split('.');
    const fileExtension = fileNameParts[fileNameParts.length - 1];
    
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve({
        fileName: file.name,
        fileData: reader.result,
        contentType: file.type,
        extension: fileExtension,
      });
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });
};

export const prepareFileForUpload = (fileData: FileData) => {
  return {
    content: (fileData.fileData as string).split(',')[1],
    contentEncodingType: 'base64',
    contentType: fileData.contentType,
  };
};

export const prepareFilesForUpload = (files: FileData[]) => {
  return files.map(prepareFileForUpload);
};